import React from 'react'
import SbEditable from 'storyblok-react'

const ContactBannerBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="contact-banner-block">
        <div className="contact-banner-block-color">
          <div className="contact-banner-block-container">
            <div className="contact-banner-block-wrapper">
              <div className="contact-banner-block-row">
                <div className="contact-banner-block-text">
                  <span className="contact-banner-block-text-inner">
                    {block.text}
                  </span>
                </div>
                <div
                  className="contact-banner-block-embed"
                  dangerouslySetInnerHTML={{ __html: block.code }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default ContactBannerBlock
